import Swiper, { Navigation, Pagination } from 'swiper';
// import SmoothScroll from 'smooth-scroll';
export default class VoiceSlider {
  constructor() {
    this.init();
  }

  init() {
    if (!document.querySelector('.p_RecruitPage')) {
      return false;
    }
    const swiper = new Swiper('.swiper', {
      modules: [Navigation, Pagination],
      centeredSlides: true,
      spaceBetween: 20,
      slidesPerView: 1.2,
      loop: true,
      speed: 500,
      breakpoints: {
        768: {
          slidesPerView: 1,
          spaceBetween: 30,
        },
      },
      navigation: {
        nextEl: '.p_RecruitPageVoice-next',
        prevEl: '.p_RecruitPageVoice-prev',
      },
    });
  }
}
